import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Menu, {tooltipId} from "components/Notifications/Menu";
import MenuItem from "components/Notifications/MenuItem";
import {connect} from "react-redux";

const featureTitle = "Case Alerts";

class Notifications extends React.Component {

    constructor(props) {
        super(props);
        this.getIcon = this.getIcon.bind(this);
        this.getIconClassName = this.getIconClassName.bind(this);
        this.checkIfClickOutsideOfMenu = this.checkIfClickOutsideOfMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.mapNotificationsToMenuItems = this.mapNotificationsToMenuItems.bind(this);
        this.newNotifications = this.newNotifications.bind(this);
        this.Feature = React.createRef();
        this.Menu = React.createRef();
        this.state = {
            isMenuOpen: false,
            newNotifications: this.newNotifications(),
        };
    }

    componentDidMount() {
        window.addEventListener("click", this.checkIfClickOutsideOfMenu);
        window.addEventListener("resize", this.hideMenu);
    }

    componentDidUpdate() {
        const newNotifications = this.newNotifications();
        if(this.state.newNotifications !== newNotifications)
            this.setState({
                newNotifications: newNotifications,
            });        
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.checkIfClickOutsideOfMenu);
        window.addEventListener("resize", this.hideMenu);
    }

    getIcon() {
        const {newNotifications} = this.state;
        if(newNotifications)
            return "notifications";
        return "notifications_none";
    }

    getIconClassName() {
        const {isMenuOpen} = this.state;
        return `md-icon material-icons${isMenuOpen ? " active" : " inactive"}`;
    }

    checkIfClickOutsideOfMenu(e) {
        const {isMenuOpen} = this.state;
        if(isMenuOpen && !this.Feature.current.contains(e.target)) {
            this.hideMenu();
        }
    }

    hideMenu() {
        this.Menu.current.hideTooltip();
        this.setState({
            isMenuOpen: false,
        });
    }

    mapNotificationsToMenuItems() {
        const {notifications} = this.props;
        return notifications.map(notification => { return {
            key: notification.id,
            control: <MenuItem notification={notification}/>,
        };});
    }

    newNotifications() {
        const {notifications} = this.props;
        return notifications.find(notification => notification.isNew) || false;
    }

    render() {
        const {className} = this.props;
        const {isMenuOpen} = this.state;
        return (
            <div
                ref={this.Feature}
                className={className}
            >
                <i 
                    title={featureTitle}
                    data-tooltip-id={tooltipId}
                    onClick={() => {
                        this.setState({
                            isMenuOpen: !isMenuOpen,
                        });
                    }}
                    className={this.getIconClassName()}
                >
                    {this.getIcon()}
                </i>
                <Menu
                    title={featureTitle}
                    items={this.mapNotificationsToMenuItems()}
                    isOpen={isMenuOpen} 
                    setMenuRef={this.Menu}
                />
            </div>
    );
    }
}

Notifications.defaultProps = {
    place: "bottom",
};

Notifications.propTypes = {
    //pure props
    place: PropTypes.string,

    //global state
    notifications: PropTypes.array,

    //styled-components prop
    className: PropTypes.string,
};

const StyldNotifications = styled(Notifications)`
    padding-top: 50%;
    & > i {
        &.active {
            color: #fff !important;
        }
        &.inactive {}
        &:hover {
            transform: scale(1.25);
        }
        &:not(:hover) {
            transform: scale(1);
        }
    }
`;

const mapStateToProps = state => {
    return {
      notifications: state.caseAlerts,
    };
  };

export default connect(mapStateToProps)(StyldNotifications);